import IntentsPage from './IntentsPage';
import IntentsPageContainer from './IntentsPage.container';

export default IntentsPageContainer(IntentsPage);
